export const getSiembiotCardQuery = (lang = 'en') => `
{
  findSiembiotCardBottomRightSingleton {
    data {
      title {
        ${lang}
      }
      text1 {
        ${lang}
      }
      btnBlueText {
        ${lang}
      }
      btnOutlineText {
        ${lang}
      }
      text2 {
        ${lang}
      }
      title2 {
        ${lang}
      }
      text3 {
        ${lang}
      }
      items {
       iv{
        data{
          text{
            ${lang}{
              textContent
            }
          }
          titleSimple{
            ${lang}
          }
          iconImage{
            iv{
              id
            }
          }
        }
      }
      }
      cardVisibleText {
        ${lang}
      }
        link1 {
        ${lang}
      }
        link2 {
        ${lang}
      }
    }
  }
}
  
`;